// extracted by mini-css-extract-plugin
export default {"section-2-container":"Section2_section-2-container__rX5FP"};